'use strict';
// adapted from https://github.com/facebook/fbjs/blob/afcf932e06793be334ac2a0afc78fd23ed356765/packages/fbjs/src/performance/performanceNow.js

'use es6';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _performance = require('./performance');

var _performance2 = _interopRequireDefault(_performance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loadTime = Date.now();

var performanceNow = _performance2.default.now ? function () {
  return _performance2.default.now();
} : function () {
  return Date.now() - loadTime;
};

exports.default = performanceNow;
module.exports = exports['default'];